// export const HOST = "http://127.0.0.1:8000";
// export const HOST = "https://0d26-122-172-201-178.ngrok-free.app";
// export const HOST = "https://marketplace-test-dot-cropwaybackend.el.r.appspot.com";
export const HOST = "https://marketplace-dot-cropwaybackend.el.r.appspot.com";
// export const HOST = "https://seller-studio-dot-cropwaybackend.el.r.appspot.com";